// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.snapshot-header {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px; /* Space below header */
  color: var(--ceoTrackTitleColor);
  user-select: none;
}

.contravention-snapshot-container {
  border: 1px solid var(--inputControlBorderColor);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  color: var(--ceoTrackTextColor);
  height: 95%;
}
.contravention-snapshot-container .snapshot-layout {
  display: flex;
  padding: 16px;
  gap: 12px;
  height: 100%;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
}
.contravention-snapshot-container .snapshot-layout .image-viewer-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}
.contravention-snapshot-container .snapshot-layout .contravention-note-label {
  font-weight: 400;
  font-size: 14px;
  color: var(--ceoTrackTextColor);
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/ContraventionSnapshot/ContraventionSnapshot.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB,EAAE,uBAAuB;EAC3C,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.snapshot-header {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 8px; /* Space below header */\n  color: var(--ceoTrackTitleColor);\n  user-select: none;\n}\n\n.contravention-snapshot-container {\n  border: 1px solid var(--inputControlBorderColor);\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  color: var(--ceoTrackTextColor);\n  height: 95%;\n}\n.contravention-snapshot-container .snapshot-layout {\n  display: flex;\n  padding: 16px;\n  gap: 12px;\n  height: 100%;\n  box-sizing: border-box;\n  min-height: 0;\n  overflow: hidden;\n}\n.contravention-snapshot-container .snapshot-layout .image-viewer-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n}\n.contravention-snapshot-container .snapshot-layout .contravention-note-label {\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--ceoTrackTextColor);\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
